class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      FacetFiltersForm.isMobileFacet = this.querySelector('#FacetFiltersFormMobile') ? true : false;
      FacetFiltersForm.isCustomer = document.getElementById('FacetFiltersForm').dataset.customer == 'true' ? true : false;
      FacetFiltersForm.filterSectionID = document.getElementById('main-collection-filters').dataset.id;
      FacetFiltersForm.emptyTemplateFetched = false;

      if(!document.querySelector('[data-pages]') && FacetFiltersForm.isCustomer) { document.querySelector('.facets-container').classList.add('visually-hidden'); };

      if(FacetFiltersForm.isCustomer && !FacetFiltersForm.isMobileFacet) {
        let url = document.location.url;
        let searchParams = (new URL(document.location)).searchParams;
        FacetFiltersForm.renderPageWhenCustomer(searchParams, false);
      }
    });
  }

  static renderPageWhenCustomer(searchParams, updateURLHash) {
    if(!document.querySelector('[data-pages]')) { return };
    FacetFiltersForm.pages = document.querySelector('[data-pages]').dataset.pages;
    searchParams.set('page', 1);
    FacetFiltersForm.renderPage(searchParams, null, updateURLHash);

    FacetFiltersForm.currentPage = 1;

    for(let index = 1; index < FacetFiltersForm.pages; index++) {
      FacetFiltersForm.currentPage = FacetFiltersForm.currentPage + 1;
      searchParams.set('page', FacetFiltersForm.currentPage);
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    FacetFiltersForm.fetchEmptyTempate();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      let searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      if(FacetFiltersForm.isCustomer) {
        FacetFiltersForm.filterData = [];
        searchParams = new URLSearchParams(searchParams)
        searchParams.set('page', 1);
        FacetFiltersForm.renderPageWhenCustomer(searchParams, false);

      } else {
        FacetFiltersForm.renderPage(searchParams, null, false);
      }
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = element => element.url === url;

      if(FacetFiltersForm.isCustomer) {
        let sectionName = 'collection-ajax';
        if(window.location.pathname.includes('search')) {
          sectionName = 'search-ajax';
        }

        url = `${window.location.pathname}?sections=${sectionName}&${searchParams}`;
      }

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        if(FacetFiltersForm.isCustomer) {
          let params = new URLSearchParams(url);
          let page = params.get('page');
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url, page }].sort((a, b) => (parseInt(a.page) > parseInt(b.page)) ? 1 : -1);

          if(FacetFiltersForm.filterData.length == FacetFiltersForm.pages) {
            FacetFiltersForm.renderFilters(html, event);
            FacetFiltersForm.renderProductGridContainer(FacetFiltersForm.filterData);
            FacetFiltersForm.renderProductCount(html);
          }
        } else {
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        }
      });

  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if(FacetFiltersForm.isCustomer) {
      if(FacetFiltersForm.filterData.length == FacetFiltersForm.pages) {
        FacetFiltersForm.renderProductCount(html);
      }
    } else {
      FacetFiltersForm.renderProductCount(html);
    }
  }

  static renderProductGridContainer(html) {
    if(!FacetFiltersForm.isCustomer) {
      let parsedHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
      if(!parsedHtml) { return; }
      document.getElementById('ProductGridContainer').innerHTML = parsedHtml.innerHTML;
      document.getElementById('ProductGridContainer').classList.remove('loading');
    } else {
      let path = 'collection-ajax';
      let element = '#product-grid';
      if(document.location.pathname.includes('search')) {
        path = 'search-ajax';
      }

      let fullHtml = '';
      [...html].map((section, index) => {
        let parsedState = JSON.parse(section.html);
          fullHtml += FacetFiltersForm.getSectionInnerHTML(parsedState[path], element);
      });

      document.getElementById('ProductGridContainer').querySelector('#product-grid').innerHTML = fullHtml;
      document.getElementById('ProductGridContainer').classList.remove('loading');
      FacetFiltersForm.renderProductCount(html);
    }
  }

  static renderProductCount(html) {
    const products = document.querySelectorAll('#product-grid .grid__item:not(.grid__item--placeholder)');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    let count;

    if(FacetFiltersForm.isCustomer) {
      if(window.location.pathname.includes('search')) {
        let searchTextElement = document.querySelector('[data-search-text]');
        searchTextElement.innerHTML = searchTextElement.dataset.searchText.replace('$$', products.length);

        if(products.length == 0 && FacetFiltersForm.currentPage == FacetFiltersForm.pages) {
          document.querySelector('.facets-container').classList.add('visually-hidden');
        }
      } else {
        if(products.length == 0 && FacetFiltersForm.currentPage == FacetFiltersForm.pages) {
          FacetFiltersForm.renderEmptyTemplate();
        }
      }
      count = containerDesktop.dataset.countText.replace('$$', products.length);
    } else {
      count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      if(window.location.pathname.includes('search')) {
        let searchTextElement = document.querySelector('[data-search-text]');
        searchTextElement.innerHTML = searchTextElement.dataset.searchText.replace('$$', count.replace(/[^0-9]/g, ''));

        if(products.length == 0 && FacetFiltersForm.currentPage == FacetFiltersForm.pages) {
          document.querySelector('.facets-container').classList.add('visually-hidden');
        }
      }
    }
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderEmptyTemplate() {
    //console.log(FacetFiltersForm.emptyTemplateHtml);
    if(FacetFiltersForm.emptyTemplateFetched) {
      document.getElementById('ProductGridContainer').innerHTML = FacetFiltersForm.emptyTemplateHtml;
    } else {
      setTimeout(() => {
        FacetFiltersForm.renderEmptyTemplate();
      }, 100);
      return;
    }
    FacetFiltersForm.renderFilters();
  }

  static fetchEmptyTempate() {
    fetch(`${window.location.pathname}?sections=collection-empty`).then(response => { return response.text(); })
    .then((state) => {
      const parsedState = JSON.parse(state);
      FacetFiltersForm.emptyTemplateHtml = FacetFiltersForm.getSectionInnerHTML(parsedState['collection-empty'], '#shopify-section-collection-empty');
      FacetFiltersForm.emptyTemplateFetched = true;
    });
  }

  static getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  static renderFilters(html, event) {
    let url = `${window.location.pathname}?section_id=${FacetFiltersForm.filterSectionID}&${FacetFiltersForm.searchParamsPrev}`;
    fetch(url).then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }
      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData);
    FacetFiltersForm.filterData = [];

    if(FacetFiltersForm.isCustomer) {
      for(let index = 1; index <= FacetFiltersForm.pages; index++) {
        searchParams.set('page', index);
        FacetFiltersForm.renderPage(searchParams.toString(), null, index < 2);
      }
    } else {
      FacetFiltersForm.renderPage(searchParams.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    FacetFiltersForm.filterData = [];

    let searchParams = new URL(event.currentTarget.href).searchParams;
    if(FacetFiltersForm.isCustomer) {
      for(let index = 1; index <= FacetFiltersForm.pages; index++) {
        searchParams.set('page', index);
        FacetFiltersForm.renderPage(searchParams.toString(), null, index < 2);
        event.currentTarget.parentElement.remove();
      }
    } else {
      FacetFiltersForm.renderPage(searchParams.toString());
    }
  }
}

FacetFiltersForm.currentPage = 1;
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);